export interface ForemanEquipment {
  foremanEquipmentID: string;
  equipmentID: string | null;
  unitID: string | null;
  name: string | null;
  altID: string | null;
  description: string | null;
  foremanNotes: string | null;
  bActive: boolean | null;
}
